<template>
  <div>
    <div class="container">
      <div class="products-table">
        <div class="global-search">
          <div class="col-left">
            <i class="icon-filter mr-2"></i> Filtrar resultados
          </div>

          <div class="col-right">
            <div class="search-bar clearfix">
              <input
                type="text"
                class="form-control"
                v-model="searchData"
                placeholder="Busque pelo produto, filtro ou equivalência"
                @keyup.enter="search"
              >
              <button type="button" class="btn btn-primary btn-search" @click="search">
                <i class="icon-search"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="table-contents">
          <div class="filters-group d-none d-md-block">

            <release-filters
              :releases="releases"
              :key="update"
              @update:releases="filteredReleases = $event.releases, totalItems = $event.total, paginate(1, false)"
              @update:listReleaseFilters="listReleaseFilters = $event.releases"
              @update:isLoading="isLoading = $event"
            ></release-filters>
          </div>

          <div class="products-group">
            <div class="item">
              <div class="row">
                <div
                  class="col-md-6 text-center text-md-left"
                >{{totalItems}} Resultados para “Últimos lançamentos”</div>
                <div class="col-md-6 mt-3 mt-md-0"></div>
              </div>
            </div>

            <div class="item d-none d-md-block">
              <span class="light mr-2">Filtros selecionados ({{listReleaseFilters.length}})</span>
              <span
                v-for="(filter, index) in listReleaseFilters"
                v-if="filter != null || filter != ''"
              >{{filter}} {{index + 1 < listReleaseFilters.length ? ' + ' : '' }}</span>
            </div>

            <spinner v-if="isLoading"></spinner>
            <release-list v-else :releases="filteredReleases" :key="update"></release-list>

            <div class="item border-md-0">
              <div class="row" :class="{'d-none': !filteredReleases.length || isLoading}">
                <div
                  class="text-center col-md-6 text-md-left d-none d-md-block"
                >Exibindo {{filteredReleases.length}} {{ filteredReleases.length > 1 ? 'lançamentos' : 'lançamento'}} de {{totalItems}}</div>
                <div class="mt-3 col-md-6 mt-md-0" v-bind:class="{'d-none': totalPages <= 1}">
                  <pagination
                    ref="pager"
                    :pages="pages"
                    :current-page="currentPage"
                    :total-pages="totalItems"
                    :key="update"
                    @update:changePage="paginate"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="diagonal-line"></div>
  </div>
</template>

<script>
import ReleaseAPI from "@/api/release";
import VehicleAPI from "@/api/vehicle";
import PartAPI from "@/api/part";

import ReleaseFilters from "@/components/ReleaseFilters.vue";
import ReleaseList from "@/components/ReleaseList.vue";
import Pagination from "@/components/Pagination.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "Releases",
  data() {
    return {
      searchData: "",
      releases: [],
      filteredReleases: [],
      listReleaseFilters: [],
      url: "https://static.japanparts.com.br",
      update: 0,

      releasesPerPage: 15,
      pages: [],
      totalPages: 0,
      totalItems: 0,
      currentPage: 1,

      isLoading: true
    };
  },
  async mounted() {
    await this.loadReleases(this.currentPage);
    this.paginate(1);
    this.update++;
  },
  components: { ReleaseFilters, ReleaseList, Pagination, Spinner },
  methods: {
    async loadReleases(page = 1) {
      try {
        this.isLoading = true
        const { hits, total } = await ReleaseAPI.getReleases("", "", "", "", page, this.releasesPerPage);
        this.releases = hits;
        this.totalItems = total;
        this.filteredReleases = this.releases;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async search() {
      const cars = await VehicleAPI.search(this.searchData);
      const parts = await PartAPI.search(this.searchData);
      this.$root.$data.searchData = this.searchData;
      this.$root.$data.cars = cars.data;
      this.$root.$data.parts = parts.data;
      let find = parts.data.hits.find(item => item.code === this.searchData.toUpperCase() || item.original.equivalence_code == this.searchData.toUpperCase() || item.equivalencies.find(equiv => equiv.equivalence_code == this.searchData.toUpperCase()));
      if (find) {
        this.$router.push(`/produto/${find.code}`);
      } else {
        this.$router.push("/produtos");
      }
    },

    openPart(code) {
      this.$router.push(`/produto/${code}`);
    },

    paginate(page, shouldChangePage = true) {
      const { paginate } = this.$refs.pager;
      [this.totalPages, this.pages, this.currentPage] = paginate(page, this.currentPage, this.totalItems, this.releasesPerPage, shouldChangePage, this.changePage)
    },

    async changePage(page) {
      try {
        this.loadReleases(page);
      } catch (err) {
        console.log(err);
      } finally {
        this.update++;
      }
    },
  }
};
</script>

<style scoped>
a {
  cursor: pointer;
}
a:not([href]):not([tabindex]) {
  color: #ccb025;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: #0056b3;
}
</style>



// WEBPACK FOOTER //
// src/pages/Releases.vue